/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

export type ModalItem = { id?: string; label?: string; disableVisibilityToggle?: boolean } & any;

export interface PropsShape {
    selectableItems: ModalItem[];
    modalTitle: string;
    modalSubtitle: string;
    selectAllText: string;
    deselectAllText: string;
    saveText: string;
    cancelText: string;
    selectedItems: ModalItem[];
    setSelectedItems: (items: ModalItem[]) => void;
    itemIdsToShow?: string[];
    hideToggle?: boolean;
    numberOfColumns?: number;
}

export const MultiSelectModal = (props: PropsShape) => {
    const {
        selectableItems,
        modalTitle,
        modalSubtitle,
        selectAllText,
        deselectAllText,
        saveText,
        cancelText,
        selectedItems,
        setSelectedItems,
        itemIdsToShow,
        hideToggle,
        numberOfColumns,
    } = props;

    const [showModal, setShowModal] = useState<boolean>(false);
    const [toggledItems, setToggledItems] = useState<ModalItem[]>(selectableItems || []);

    return (
        <>
            {!hideToggle && (
                <div className="multi-select-modal-toggle-container">
                    <button
                        className="multi-select-modal-toggle-button"
                        onClick={() => setShowModal(true)}
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: modalTitle,
                            }}
                        />
                    </button>
                </div>
            )}

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                data-testid="multi-select-modal"
            >
                <Modal.Header closeButton>
                    <div className="multi-select-modal-header">
                        <div
                            className="multi-select-modal-title"
                            dangerouslySetInnerHTML={{
                                __html: modalTitle,
                            }}
                        />
                        <div className="multi-select-modal-subtitle">{modalSubtitle}</div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="multi-select-modal-select-deselect">
                        <button
                            className="multi-select-modal-select-all-btn"
                            onClick={() => {
                                if (itemIdsToShow) {
                                    const newItems = selectableItems.filter(
                                        (item: ModalItem) =>
                                            itemIdsToShow.includes(item.id) &&
                                            !toggledItems.map((t) => t.id).includes(item.id)
                                    );

                                    const newToggledItems = [...toggledItems, ...newItems];

                                    newToggledItems.sort(
                                        (a, b) =>
                                            selectableItems.findIndex((i) => i.id === a.id) -
                                            selectableItems.findIndex((i) => i.id === b.id)
                                    );

                                    setToggledItems(newToggledItems);
                                } else {
                                    setToggledItems(selectableItems || []);
                                }
                            }}
                        >
                            {selectAllText}
                        </button>
                        <button
                            className="multi-select-modal-deselect-all-btn"
                            onClick={() => {
                                if (itemIdsToShow) {
                                    const newItems = toggledItems.filter(
                                        (item: ModalItem) =>
                                            item.disableVisibilityToggle ||
                                            !itemIdsToShow.includes(item.id)
                                    );

                                    setToggledItems(newItems);
                                } else {
                                    const alwaysShownItems =
                                        selectableItems?.filter(
                                            (item: ModalItem) => item.disableVisibilityToggle
                                        ) || [];

                                    setToggledItems([...alwaysShownItems]);
                                }
                            }}
                        >
                            {deselectAllText}
                        </button>
                    </div>
                    <div
                        className="multi-select-modal-items-container"
                        style={{ columns: numberOfColumns || 2 }}
                    >
                        {selectableItems
                            ?.filter(
                                (item: ModalItem) =>
                                    !item.disableVisibilityToggle &&
                                    (!itemIdsToShow || itemIdsToShow.includes(item.id))
                            )
                            ?.map((item: ModalItem) => (
                                <div key={item.id}>
                                    <input
                                        className="multi-select-modal-item-input"
                                        data-testid={`multi-select-modal-item-${item.id}`}
                                        type="checkbox"
                                        id={`multi-select-modal-item-${item.id}`}
                                        checked={!!toggledItems.find((i) => i.id === item.id)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setToggledItems((prevToggledItems) => {
                                                    const newToggledItems = [
                                                        ...prevToggledItems,
                                                        item,
                                                    ];

                                                    return newToggledItems.sort(
                                                        (a, b) =>
                                                            selectableItems.findIndex(
                                                                (i) => i.id === a.id
                                                            ) -
                                                            selectableItems.findIndex(
                                                                (i) => i.id === b.id
                                                            )
                                                    );
                                                });
                                            } else {
                                                setToggledItems((prevToggledItems) =>
                                                    prevToggledItems.filter((i) => i.id !== item.id)
                                                );
                                            }
                                        }}
                                    />
                                    <label
                                        className="multi-select-modal-item"
                                        htmlFor={`multi-select-modal-item-${item.id}`}
                                        dangerouslySetInnerHTML={{ __html: item.label }}
                                    />
                                </div>
                            ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="multi-select-modal-cancel-button"
                        onClick={() => {
                            setToggledItems(selectedItems);
                            setShowModal(false);
                        }}
                    >
                        {cancelText}
                    </button>
                    <button
                        className="multi-select-modal-save-button"
                        onClick={() => {
                            setSelectedItems(toggledItems);
                            setShowModal(false);
                        }}
                    >
                        {saveText}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
